import { createAsyncThunk, createSlice, current } from "@reduxjs/toolkit";
import { AxiosError } from "axios";
import { RootState } from "features/config/store";
import { GetOrderConfigModel } from "features/stock-ordering/core/domain/order-config.model";
import {
  GetOrderConfigRepository,
  GetOrderConfigResponse,
} from "features/stock-ordering/data/stock-ordering.repository";

export enum GetOrderConfigState {
  initial,
  inProgress,
  success,
  fail,
}

interface InitialState {
  status: GetOrderConfigState;
  message: string;
  data: GetOrderConfigModel | undefined;
}

const initialState: InitialState = {
  status: GetOrderConfigState.initial,
  message: "",
  data: undefined,
};

export const getOrderConfig = createAsyncThunk(
  "getOrderConfig",
  async (param: string, { rejectWithValue }) => {
    try {
      const response: GetOrderConfigResponse = await GetOrderConfigRepository(
        param
      );
      return response.data;
    } catch (error) {
      if (error instanceof AxiosError) {
        if (!error.response) {
          throw error;
        }
        throw rejectWithValue(error.response.data.message);
      }
    }
  }
);

/* Main Slice */
export const getOrderConfigSlice = createSlice({
  name: "getOrderConfig",
  initialState,
  reducers: {
    resetGetOrderConfig: (state) => {
      state.status = GetOrderConfigState.inProgress;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getOrderConfig.pending, (state) => {
        state.status = GetOrderConfigState.inProgress;
      })
      .addCase(getOrderConfig.fulfilled, (state, action) => {
        if (action.payload) {
          const { message, data } = action.payload;
          state.status = GetOrderConfigState.success;
          state.message = message;
          state.data = data;
        }
      })
      .addCase(getOrderConfig.rejected, (state, action) => {
        state.status = GetOrderConfigState.fail;
        state.message = action.payload as string;
        state.data = undefined;
      });
  },
});

export const selectGetOrderConfig = (state: RootState) => state.getOrderConfig;

export const { resetGetOrderConfig } = getOrderConfigSlice.actions;
export default getOrderConfigSlice.reducer;
